import React, { useEffect, useState } from "react";
import { MdEdit, MdDelete } from "react-icons/md";
import EditModal from "./shared/EditModal";
import SUG from "./shared/suggestions";

export default function EducationSection({ value = [], onChange }) {
  const [items, setItems] = useState(value || []);
  const [open, setOpen] = useState(false);
  const [editIdx, setEditIdx] = useState(null);

  useEffect(() => setItems(value || []), [value]);

  const years = generateYears();
  const fields = [
    { name: "course", label: "Course", type: "text", suggestList: SUG.courses },
    { name: "specialization", label: "Specialization", type: "text", suggestList: SUG.specializations },
    { name: "institute", label: "Institute", type: "text", suggestList: SUG.institutes },
    { name: "startYear", label: "Start Year", type: "select", options: years },
    { name: "endYear", label: "End Year", type: "select", options: years },
  ];

  function generateYears() {
    const cur = new Date().getFullYear();
    const arr = [];
    for (let y = cur; y >= 1980; y--) arr.push(String(y));
    return arr;
  }

  const openAdd = () => { setEditIdx(null); setOpen(true); };
  const openEdit = (i) => { setEditIdx(i); setOpen(true); };

  const save = (obj) => {
    const next = [...items];
    if (editIdx == null) next.push(obj); else next[editIdx] = obj;
    setItems(next); onChange(next); setOpen(false);
  };

  const remove = (i) => { const next = items.filter((_, idx) => idx !== i); setItems(next); onChange(next); };

  return (
    <section className="ccard">
      <div className="card-head"><h3>Education</h3><div className="card-actions"><button className="link" onClick={openAdd}>Add</button></div></div>

      <div className="card-body">
        {items.length === 0 ? <p className="muted">No education yet</p> : items.map((it, i) => (
          <div className="item-row" key={i}>
            <div>
              <div className="item-title">{it.course} — {it.specialization || ""}</div>
              <div className="muted">{it.institute}  {it.startYear} — {it.endYear}</div>
            </div>
            <div className="item-actions">
              
              <MdEdit  title="Edit" className="smalll" onClick={() => openEdit(i)}  />
              <MdDelete title="Delete" className="smalll danger" onClick={() => remove(i)}/>
            </div>
          </div>
        ))}
      </div>

      {open && <EditModal title={editIdx==null?"Add education":"Edit education"} initial={editIdx==null?{}:items[editIdx]} fields={fields} onClose={()=>setOpen(false)} onSave={save} />}
    </section>
  );
}
